import * as React from 'react';
import cx from 'clsx';
import { getDisplayedDecimalsAmount, getCurrencySymbol } from './utils';
import { JackpotBoxScale, JackpotState, WrapperType } from '../../types';
import styles from './JackpotNumber.module.scss';

export interface JackpotNumberProps {
  currencyCode: string;
  value: number;
  jackpotScale: JackpotBoxScale;
  jackpotState: JackpotState;
  locale: string;
  wrapperType: WrapperType;
}

export const JackpotNumber: React.FC<JackpotNumberProps> = ({
  currencyCode,
  jackpotScale,
  jackpotState,
  locale,
  wrapperType,
  value = 0,
}) => {
  const currencySymbol = getCurrencySymbol(currencyCode, locale);

  const displayedDecimalsAmount = getDisplayedDecimalsAmount(value);
  const numberArray = (value || 0)
    .toLocaleString(locale, {
      minimumFractionDigits: displayedDecimalsAmount,
      maximumFractionDigits: displayedDecimalsAmount,
    })
    .split('');

  const isSpecialState = ['active', 'won'].includes(jackpotState);
  return (
    <div className={styles.container} data-testid="jackpot-number">
      <div className={styles.currency} data-testid="jackpot-currency">
        {currencySymbol}
      </div>
      {numberArray.map((digit, i) =>
        Number.isInteger(parseInt(digit, 10)) ? (
          <div
            className={cx(
              styles.box,
              jackpotScale === 'medium' && styles.boxMedium,
              styles[
                `boxBackground__${wrapperType}__${
                  isSpecialState ? 'special' : 'normal'
                }`
              ]
            )}
            data-testid="jackpot-digit-box"
            key={i}
          >
            <div
              className={cx(
                styles.digit,
                jackpotScale === 'medium' && styles.digitMedium
              )}
              data-testid="jackpot-digit"
            >
              {digit}
            </div>
          </div>
        ) : (
          <div className={styles.char} data-testid="jackpot-char" key={i}>
            {digit}
          </div>
        )
      )}
    </div>
  );
};
